import {Component, OnInit, TemplateRef} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {IAfterGuiAttachedParams, ICellRendererParams} from 'ag-grid-community';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'lib-sendungereignis-info-cell',
  templateUrl: './sendungereignis-info-cell.component.html',
  styleUrls: ['./sendungereignis-info-cell.component.css']
})
export class SendungereignisInfoCellComponent implements ICellRendererAngularComp, OnInit {
  modalRef: BsModalRef;
  public params;
  faInfoCircle = faInfoCircle;

  public sendungsereignis;

  constructor(private modalService: BsModalService) { }

  ngOnInit(): void {
    this.sendungsereignis = this.params.data;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  displayInfos(template: TemplateRef<any>): void {
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(template, config);
  }

}
